/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as NotificationDefs from './defs.defs.js'

const $nsid = 'chat.bsky.notification.putPreferences'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  chat: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.ChatPreference>(
      (() => NotificationDefs.chatPreference) as any,
    ),
  ),
  chatRequest: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.ChatPreference>(
      (() => NotificationDefs.chatPreference) as any,
    ),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  preferences: /*#__PURE__*/ l.ref<NotificationDefs.Preferences>(
    (() => NotificationDefs.preferences) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Set the requesting account's chat notification preferences. Only the provided preferences are updated; omitted preferences are left unchanged. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
